export default {
    languageConstants: {
        languages: {
            English: "en-US",
            Spanish: "es-ES",
            Arabic: "ar-SA",
            German: "de-DE",
        },
        default: "English",
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/language-constants.ts